<template>
  <div class="equipment">
    <div class="equipment_top">
      <div class="equipment_return">
        <i class="el-icon-arrow-left fl"></i>
        <span class="fl">返回</span>
      </div>
      <h1>设备信息</h1>
      <div class="equipment_time clearfix">
        <i class="el-icon-date fl"></i>
        <span class="fl">{{ dataTime }}</span>
      </div>
    </div>

    <div class="equipment_center">
      <!-- 搜索 -->
      <div class="query_box clearfix">
        <div class="equipment_query fl">
          <el-input placeholder="请输入内容" v-model="input1">
            <template slot="prepend">设备ID</template>
          </el-input>
        </div>
        <div class="equipment_query fl">
          <el-input placeholder="请输入内容" v-model="input1">
            <template slot="prepend">设备名称</template>
          </el-input>
        </div>

        <div class="equipment_query fl">
          <el-button type="primary" icon="el-icon-search">搜索</el-button>
        </div>

        <div class="fr">
          <el-button
            type="success"
            icon="el-icon-circle-plus-outline"
            @click="add = true"
            >新增</el-button
          >
          <el-button type="info" icon="el-icon-edit" @click="modify = true"
            >修改</el-button
          >
          <el-button type="danger" icon="el-icon-delete">删除</el-button>
        </div>
      </div>

      <!-- 数据列表 -->
      <div class="equipment_data">
        <div class="equipment_title clearfix">
          <div class="title fl">
            <el-checkbox v-model="checked"></el-checkbox>
          </div>
          <div class="title fl">设备ID</div>
          <div class="title fl">设备名称</div>
          <div class="title fl">所属机构</div>
          <div class="title fl">在线状态</div>
          <div class="title fl">创建时间</div>
          <div class="title fl">操作</div>
        </div>
        <div
          class="equipment_list clearfix"
          v-for="(item, index) in 10"
          :key="index"
        >
          <div class="list fl">
            <el-checkbox v-model="checked"></el-checkbox>
          </div>
          <div class="list fl">970140</div>
          <div class="list fl">01-sc</div>
          <div class="list fl">广州奥典</div>
          <div class="list fl">在线</div>
          <div class="list fl">2022-02-17 09:30:15</div>
          <div class="list fl">
            <el-popover placement="left" width="400" trigger="click">
              <div>111</div>
              <el-button type="primary" size="mini" slot="reference"
                >查看详情</el-button
              >
            </el-popover>
          </div>
        </div>

        <div class="equipment_btn">
          <span>共13页，108条数据</span>
          <el-pagination background layout="prev, pager, next" :total="1000">
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 添加机构 -->
    <el-drawer
      title="添加机构信息"
      :visible.sync="add"
      :modal-append-to-body="false"
      size="40%"
    >
      <div class="add_box">添加!</div>
    </el-drawer>

    <!-- 修改机构 -->
    <el-drawer
      title="修改机构信息"
      :visible.sync="modify"
      :modal-append-to-body="false"
      size="40%"
    >
      <div class="modify_box">修改!</div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 定时器
      time: "",
      // 日期时间
      dataTime: "",

      input1: "",
      checked: false,

      // 添加
      add: false,
      // 修改
      modify: false,
    };
  },
  created() {
    //   获取时间日期
    this.dataTimes();
    // 清除定时器
    window.clearInterval(this.time);
    let _this = this;
    // 定时更新时间
    this.time = setInterval(() => {
      _this.dataTimes();
    }, 1000);
  },
  methods: {
    //  日期时间
    dataTimes() {
      let time = new Date();
      let n = time.getFullYear();
      let y = time.getMonth() + 1;
      let r = time.getDate();
      let s = time.getHours();
      let f = time.getMinutes();
      let m = time.getSeconds();

      y = y > 9 ? y : "0" + y;
      r = r > 9 ? r : "0" + r;
      s = s > 9 ? s : "0" + s;
      f = f > 9 ? f : "0" + f;
      m = m > 9 ? m : "0" + m;

      this.dataTime = n + "-" + y + "-" + r + " " + s + ":" + f + ":" + m;
    },
  },
};
</script>

<style lang="less" scoped>
.equipment {
  position: fixed;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background-color: rgb(247, 244, 244);
  .equipment_top {
    width: 100%;
    height: 50px;
    background-color: #304156;
    position: relative;
    h1 {
      width: 200px;
      margin: 0 auto;
      height: 50px;
      line-height: 50px;
      font-size: 26px;
      letter-spacing: 6px;
      font-weight: bold;
      text-align: center;
      color: #fff;
    }
    .equipment_return {
      position: absolute;
      top: 0;
      left: 0;
      height: 50px;
      overflow: hidden;
      line-height: 50px;
      color: #fff;
      &:hover {
        cursor: pointer;
        text-shadow: #000 0 0 2px;
      }
      i {
        font-weight: bold;
        margin-left: 20px;
        font-size: 20px;
        line-height: 52px;
      }
      span {
        line-height: 50px;
        font-size: 20px;
      }
    }
    .equipment_time {
      position: absolute;
      top: 0;
      right: 0;
      height: 50px;
      padding: 0 20px;
      color: #fff;
      i {
        font-size: 32px;
        line-height: 50px;
      }
      span {
        margin: 0 20px;
        font-size: 28px;
        line-height: 50px;
      }
    }
  }
}

.equipment_center {
  width: 100%;
  height: calc(100% - 50px);
  overflow-y: auto;
  padding: 20px 10px;
  box-sizing: border-box;
  background-color: #fff;
  .query_box {
    margin-bottom: 15px;
    .equipment_query {
      margin-right: 20px;
    }
  }

  .equipment_data {
    width: 100%;
    border: 1px solid #ebeef5;
    .equipment_title {
      width: 100%;
      height: 40px;
      border-bottom: 1px solid #ebeef5;
      background-color: #f4f8fb;
      .title {
        width: calc(100% / 7);
        text-align: center;
        font-weight: bold;
        font-size: 14px;
        line-height: 40px;
        color: #666666;
        border-right: 1px solid #ebeef5;
        box-sizing: border-box;
        &:last-child {
          border: none;
        }
      }
    }
    .equipment_list {
      width: 100%;
      height: 40px;
      border-bottom: 1px solid #ebeef5;
      .list {
        width: calc(100% / 7);
        text-align: center;
        font-size: 14px;
        line-height: 40px;
        color: #666666;
        border-right: 1px solid #ebeef5;
        box-sizing: border-box;
        &:last-child {
          border: none;
        }
      }
    }
    .equipment_btn {
      width: 100%;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        margin: 0 20px;
        color: #666666;
      }
    }
  }
}
</style>